import { Box, Button, Grid, MenuItem, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomSelect from "../../../../../components/common/Select";

interface MappingFileCommentsKeysProps {
  setOpen: (value: React.SetStateAction<boolean>) => void;
  readCommentsFile: () => Promise<void>;
  onBack: () => void;
  fieldsMapped: {
    last_name: string;
    first_name: string;
    email: string;
    phone_number: string;
    comment: string;
  };
  headingsFromFile: string[];
  updateFieldsMapped: (
    name: "email" | "first_name" | "last_name" | "phone_number" | "comment",
    value: string
  ) => void;
}

export const MappingFileCommentsKeys: React.FC<
  MappingFileCommentsKeysProps
> = ({
  setOpen,
  headingsFromFile,
  updateFieldsMapped,
  fieldsMapped,
  onBack,
  readCommentsFile,
}) => {
  return (
    <Stack sx={{ width: "100%", padding: "1.3rem" }}>
      <Grid container spacing={2}>
        <Grid size={4} spacing={2}>
          <MappingAttribute name="First Name" />
          <MappingAttribute name="Last Name" />
          <MappingAttribute name="Email" />
          <MappingAttribute name="Phone Number" />
          <MappingAttribute name="Comment" />
        </Grid>
        <Grid size={4}>
          <MappingArrow />
          <MappingArrow />
          <MappingArrow />
          <MappingArrow />
          <MappingArrow />
        </Grid>
        <Grid size={4}>
          <CustomSelect
            label={"Map First Name"}
            sx={{ width: "130px", mb: ".8rem" }}
            onChange={(e) =>
              updateFieldsMapped(e.target.name as any, `${e.target.value}`)
            }
            name="first_name"
            size="small"
            defaultValue={headingsFromFile[0]}
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            label={"Map Last Name"}
            name="last_name"
            onChange={(e) =>
              updateFieldsMapped(e.target.name as any, `${e.target.value}`)
            }
            defaultValue={headingsFromFile[0]}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            defaultValue={headingsFromFile[0]}
            onChange={(e) =>
              updateFieldsMapped(e.target.name as any, `${e.target.value}`)
            }
            name="email"
            label={"Map Email"}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            label={"Map Phone Number"}
            onChange={(e) =>
              updateFieldsMapped(e.target.name as any, `${e.target.value}`)
            }
            name={"phone_number"}
            defaultValue={headingsFromFile[0]}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            label={"Map Comment"}
            name={"comment"}
            onChange={(e) =>
              updateFieldsMapped(e.target.name as any, `${e.target.value}`)
            }
            defaultValue={headingsFromFile[0]}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: "1rem",
          padding: ".5em .6em",
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
        }}
      >
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
        <Button variant="contained" onClick={readCommentsFile}>
          Proceed
        </Button>
      </Box>
    </Stack>
  );
};

const MappingAttribute: React.FC<{ name: string }> = ({ name }) => {
  return (
    <Box
      sx={{
        padding: ".6rem",
        borderRadius: "0.5rem",
        border: `1px solid #CBD5E1`,
        mb: ".5rem",
      }}
    >
      <Typography variant="body2">{name}</Typography>
    </Box>
  );
};

const MappingArrow: React.FC = () => {
  return (
    <Box
      sx={{
        padding: ".6rem",
        borderRadius: "0.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: ".5rem",
      }}
    >
      <ArrowForwardIcon sx={{ width: "100%" }} />
    </Box>
  );
};
